export const MarketingPanelSidebarData = [
  {
    title: "Campaign ID",
    subNav: [
      {
        title: "Create Campaign ID",
        path: "addCampaignID",
        cName: "sub-nav",
      },
      {
        title: "Edit/Delete Campaign ID",
        path: "editDeleteCampaignID",
        cName: "sub-nav",
      },
      // {
      //   title: "Campaign Analysis",
      //   path: "campaignAnalysis",
      //   cName: "sub-nav",
      // },
    ],
  },
  {
    title: "Push Notification",
    subNav: [
      {
        title: "ADD",
        path: "addCampaign",
        cName: "sub-nav",
      },
      {
        title: "Push Notification Analysis",
        path: "editDeleteCampaign",
        cName: "sub-nav",
      },
      // {
      //   title: "Push Notification Analysis",
      //   path: "pushNotificationAnalysis",
      //   cName: "sub-nav",
      // },
    ],
  },
  {
    title: "Email Campaign",
    subNav: [
      {
        title: "ADD MAIL ",
        path: "addMailCampaign",
        cName: "sub-nav",
      },

      {
        title: "Email Analysis",
        path: "editDeleteEmailCamp",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "WhatsApp Campaign",
    subNav: [
      {
        title: "ADD WhatsApp",
        path: "addWhatsAppCampaign",
        cName: "sub-nav",
      },

      // {
      //   title: "WhatsApp Analysis",
      //   path: "editDeleteWhatsAppCamp",
      //   cName: "sub-nav",
      // },
    ],
  },
  {
    title: "Campaign Analysis",
    link: "campaignAnalysis",
  },
  // {
  //   title: "Push Notifications",
  //   link: "sendPushNotification",
  // },
  // {
  //   title: "Push Notifications",
  //   subNav: [
  //     // {
  //     //   title: "Push Notifications",
  //     //   path: "sendPushNotification",
  //     //   cName: "sub-nav",
  //     // },
  //     // {
  //     //   title: "Push Notification Analysis",
  //     //   path: "pushNotificationAnalysis",
  //     //   cName: "sub-nav",
  //     // },
  //   ],
  // },
  {
    title: "WHATSAPP MESSAGE",
    subNav: [
      {
        title: "ADD REGISTRATION CONFIGURATION",
        path: "studentCouponAdd",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "studentCouponEdit",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "WHATSAPP MESSAGE ANALYSIS",
    link: "whatsappmessageAnalysis",
  },
  // {
  //   title: "ACTIVITY DETAILS",
  //   subNav: [
  //     {
  //       title: "Paid Page Ananlysis",
  //       path: "paidPageAnalysis",
  //       cName: "sub-nav",
  //     },
  //   ],
  // },
  {
    title: "Exam Pop-Up Notification",
    subNav: [
      {
        title: "ADD",
        path: "addExamPopUpNotification",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editExamPopUpNotification",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "All Popup",
    subNav: [
      {
        title: "ADD",
        path: "addPopUp",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editPopUp",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "Festive Banner",
    subNav: [
      {
        title: "ADD",
        path: "addFestiveBanner",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "STORY TYPE",
    subNav: [
      {
        title: "ADD",
        path: "addStoryType",
        cName: "sub-nav",
      },
      {
        title: "EDIT",
        path: "editStoryType",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "EXAM SHORTS VIDEO",
    subNav: [
      {
        title: "ADD",
        path: "addExamSrcVideo",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editExamSrcVideo",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "User KYC",
    link: "userKycDetails",
  },
  {
    title: "Verify User Details",
    link: "verifyuserDetails",
  },
  {
    title: "Image Comparison & Swap",
    link: "imageComparison&Swap",
  },
  {
    title: "NOTIFICATION",
    subNav: [
      {
        title: "CREATE",
        path: "createnotification",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeletenotification",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "Login Banner",
    link: "loginBannerAdd",
  },
  {
    title: "Targeting Exam",
    link: "targetingExam",
  },
   {
    title: "WhatsApp Template Status",
    link: "whatsAppTemplateStatus",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];

export const MarketingPanelEmpSidebarData = [
  {
    title: "EMPLOYEE DETAILS",
    subNav: [
      {
        title: "Dashboard",
        path: "dashboard",
        cName: "sub-nav",
      },
      {
        title: "My Profile",
        path: "userProfile",
        cName: "sub-nav",
      },
      {
        title: "Policies",
        path: "policy",
        cName: "sub-nav",
      },
      {
        title: "KRA/KPI",
        path: "kraKpi",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "STORY TYPE",
    subNav: [
      {
        title: "ADD",
        path: "addStoryType",
        cName: "sub-nav",
      },
      {
        title: "EDIT",
        path: "editStoryType",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "EXAM SHORTS VIDEO",
    subNav: [
      {
        title: "ADD",
        path: "addExamSrcVideo",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editExamSrcVideo",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "User KYC",
    link: "userKycDetails",
  },
  {
    title: "Verify User Details",
    link: "verifyuserDetails",
  },
  {
    title: "Image Comparison & Swap",
    link: "imageComparison&Swap",
  },
  {
    title: "NOTIFICATION",
    subNav: [
      {
        title: "CREATE",
        path: "createnotification",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeletenotification",
        cName: "sub-nav",
      },
    ],
  },

  {
    title: "Login Banner",
    link: "loginBannerAdd",
  },
  {
    title: "Targeting Exam",
    link: "targetingExam",
  },
   {
    title: "WhatsApp Template Status",
    link: "whatsAppTemplateStatus",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];
